export function createLegacyBet(bet) {
    return {
        type: bet.betType,
        receiptId: bet.purchaseId,
        // eslint-disable-next-line no-null/no-null
        points: null,
        combinationOutcomes: bet.selections.map(s => ({
            providerId: 2,
            providerOutcomeId: s.selectionId,
        })),
        combinations: bet.selections.map(() => ({
            totalEnterpriseDisplayOdds: bet.originalDisplayOdds,
        }))
    };
}
//# sourceMappingURL=createLegacyBet.js.map